<template>
  <div id="request-form" class="form-section">
    <div class="container-small">
      <div class="inner">
        <div class="header-section">
          <h4 class="title-section">请求咨询</h4>
          <p class="description-section">请告知您的联系方式，我们将与您联系，安排合适的咨询时间</p></div>

        <div class="form_wrapper">
          <div class="gf_browser_chrome gform_wrapper gravity-theme gform-theme--no-framework"
               data-form-theme="gravity-theme">
            <div class="gform_anchor" tabindex="-1"></div>
            <form method="post" enctype="multipart/form-data" autocomplete="off" @submit.prevent="submitForm">
              <div class="gform-body gform_body">
                <div class="gform_fields top_label form_sublabel_below description_below validation_below">
                  <div class="gfield gfield--type-text gfield--input-type-text gfield--width-half">
                    <div class="ginput_container ginput_container_text">
                      <input name="name" type="text" value="" class="medium sb-form-field" placeholder="姓名"/>
                    </div>
                  </div>
                  <div class="gfield gfield--type-text gfield--input-type-text gfield--width-half">
                    <div class="ginput_container ginput_container_text">
                      <input name="company" type="text" value="" class="medium sb-form-field" placeholder="公司"/>
                    </div>
                  </div>
                  <div class="gfield gfield--type-text gfield--input-type-text">
                    <div class="ginput_container ginput_container_text">
                      <input name="tel" type="text" class="medium sb-form-field" placeholder="电话"/></div>
                  </div>
                  <div class="gfield gfield--type-email gfield--input-type-email">
                    <div class="ginput_container ginput_container_email">
                      <input name="mail" type="email" class="medium sb-form-field" placeholder="邮箱"/>
                    </div>
                  </div>
                  <div class="gfield gfield--type-textarea gfield--input-type-textarea full-width field_sublabel_below">
                    <div class="ginput_container ginput_container_textarea">
                      <textarea name="content" class="textarea medium sb-form-field" placeholder="内容" rows="10"
                                cols="50"></textarea>
                    </div>
                  </div>
                </div>
              </div>
              <div class="gform-footer gform_footer top_label">
                <button type="submit" class="gform_button btn_send"><span>提交表单</span></button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios"

export default {
  methods: {
    submitForm(event) {

      let layui = window.layui;
      layui.use("layer", () => {

        var layer = layui.layer;

        const formData = new FormData(event.target);
        let name = formData.get("name");
        let company = formData.get("company");
        let tel = formData.get("tel");
        let mail = formData.get("mail");
        let content = formData.get("content");

        axios.post("http://8.153.200.96/api/save-consult", {
          name: name,
          company: company,
          tel: tel,
          mail: mail,
          content: content
        })
            .then(response => {
              console.log("提交成功");
              layer.msg(response.data.msg,{icon: 3000},function (){
                 location.reload();
              });
              return;

            }).catch(error => {
          console.log("发生错误");
        })
      });


    }
  }
}
</script>